export const TAGS = [
  '摄影', '编程', '音乐', '读书', '旅行', '美食',
  '健身', '电影', '绘画', '游戏', '科技', '设计',
];

export const MOCK_USERS = [
  { id: 'u1', name: '林小溪', avatar: null, bio: '摄影爱好者，喜欢记录生活中的美好瞬间', tags: ['摄影', '旅行', '美食'] },
  { id: 'u2', name: '陈默', avatar: null, bio: '全栈开发者，开源爱好者', tags: ['编程', '科技', '设计'] },
  { id: 'u3', name: '苏暖', avatar: null, bio: '独立音乐人，吉他弹唱', tags: ['音乐', '绘画', '读书'] },
  { id: 'u4', name: '赵一鸣', avatar: null, bio: '健身教练 / 美食博主', tags: ['健身', '美食', '旅行'] },
  { id: 'u5', name: '周晓', avatar: null, bio: '游戏策划，业余画手', tags: ['游戏', '绘画', '电影'] },
];

const sampleImages = [
  'https://picsum.photos/seed/p1/600/400',
  'https://picsum.photos/seed/p2/600/400',
  'https://picsum.photos/seed/p3/600/400',
  'https://picsum.photos/seed/p4/600/400',
  'https://picsum.photos/seed/p5/600/400',
  'https://picsum.photos/seed/p6/600/400',
];

export const MOCK_POSTS = [
  {
    id: 'post1',
    userId: 'u1',
    content: '今天在西湖边拍到了绝美的日落，光线穿过柳枝的那一刻真的太美了！分享给大家',
    images: [sampleImages[0], sampleImages[1]],
    video: null,
    tags: ['摄影', '旅行'],
    likes: ['u2', 'u3', 'u4'],
    comments: [
      { id: 'c1', userId: 'u2', content: '构图太棒了！用的什么镜头？', time: Date.now() - 3600000 },
      { id: 'c2', userId: 'u3', content: '好美的光线，收藏了', time: Date.now() - 1800000 },
    ],
    createdAt: Date.now() - 7200000,
  },
  {
    id: 'post2',
    userId: 'u2',
    content: '刚用 React 18 + WebSocket 搭了一个实时聊天系统，性能优化后首屏加载快了 60%。写了篇技术总结，有兴趣的朋友可以一起交流',
    images: [sampleImages[2]],
    video: null,
    tags: ['编程', '科技'],
    likes: ['u1', 'u5'],
    comments: [
      { id: 'c3', userId: 'u5', content: '求分享源码！', time: Date.now() - 5400000 },
    ],
    createdAt: Date.now() - 10800000,
  },
  {
    id: 'post3',
    userId: 'u3',
    content: '新写了一首原创民谣《晚风书信》，录了一段弹唱视频。歌词灵感来自最近读的一本书，希望大家喜欢',
    images: [],
    video: 'https://www.w3schools.com/html/mov_bbb.mp4',
    tags: ['音乐', '读书'],
    likes: ['u1', 'u2', 'u4', 'u5'],
    comments: [
      { id: 'c4', userId: 'u1', content: '好好听！旋律很治愈', time: Date.now() - 900000 },
      { id: 'c5', userId: 'u4', content: '什么时候出完整版？', time: Date.now() - 600000 },
    ],
    createdAt: Date.now() - 14400000,
  },
  {
    id: 'post4',
    userId: 'u4',
    content: '今日份健身餐打卡：烤鸡胸 + 藜麦沙拉 + 牛油果。减脂期也能吃得很幸福！附上食谱和热量表',
    images: [sampleImages[3], sampleImages[4], sampleImages[5]],
    video: null,
    tags: ['健身', '美食'],
    likes: ['u1', 'u3'],
    comments: [
      { id: 'c6', userId: 'u3', content: '看着就好有食欲！', time: Date.now() - 2700000 },
    ],
    createdAt: Date.now() - 18000000,
  },
  {
    id: 'post5',
    userId: 'u5',
    content: '花了两周时间画的游戏角色原画终于完成了！这是一个赛博朋克风格的女战士，灵感来源于最近玩的独立游戏',
    images: [sampleImages[0]],
    video: null,
    tags: ['绘画', '游戏'],
    likes: ['u1', 'u2', 'u3', 'u4'],
    comments: [
      { id: 'c7', userId: 'u2', content: '细节太强了，光影处理得好棒', time: Date.now() - 4500000 },
      { id: 'c8', userId: 'u1', content: '大佬！请收下我的膝盖', time: Date.now() - 4200000 },
    ],
    createdAt: Date.now() - 21600000,
  },
];

export const MOCK_CONVERSATIONS = [
  {
    id: 'conv1',
    participants: ['currentUser', 'u1'],
    messages: [
      { id: 'm1', senderId: 'u1', content: '你好呀！看到你也喜欢摄影', timestamp: Date.now() - 86400000, status: 'read', recalled: false },
      { id: 'm2', senderId: 'currentUser', content: '是的！最近在学风光摄影', timestamp: Date.now() - 85000000, status: 'read', recalled: false },
      { id: 'm3', senderId: 'u1', content: '我可以推荐一些不错的拍摄地点', timestamp: Date.now() - 84000000, status: 'read', recalled: false },
    ],
  },
  {
    id: 'conv2',
    participants: ['currentUser', 'u3'],
    messages: [
      { id: 'm4', senderId: 'u3', content: '你觉得我新写的歌怎么样？', timestamp: Date.now() - 43200000, status: 'read', recalled: false },
      { id: 'm5', senderId: 'currentUser', content: '超好听！副歌部分特别抓耳', timestamp: Date.now() - 42000000, status: 'delivered', recalled: false },
    ],
  },
];

let _postIdCounter = 100;
export function nextPostId() {
  return `post_${++_postIdCounter}`;
}

let _commentIdCounter = 100;
export function nextCommentId() {
  return `c_${++_commentIdCounter}`;
}

let _messageIdCounter = 2000;
export function nextMessageId() {
  return `m_${++_messageIdCounter}`;
}
